import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0733dff0")

_pushScopeId("data-v-0733dff0")
const _hoisted_1 = { class: "loading player-adon" }
const _hoisted_2 = { class: "loader" }
const _hoisted_3 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_4 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "loading-text",
        innerHTML: _ctx.loading_text
      }, null, 8, ["innerHTML"]),
      _hoisted_3,
      (_ctx.isLoadingFullVideo)
        ? (_openBlock(), _createBlock("span", _hoisted_4, "Fetching the full video. Please wait..."))
        : _createCommentVNode("", true)
    ])
  ]))
})